.specification-int-float__container {
  display: flex;
  flex-flow: column nowrap;

  min-width: 200px;
}

.specification-int-float__container__wrapper {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 8px;

  & .ant-select-selector {
    padding: 8px 32px 8px 8px !important;
  }

  & .ant-select-single {
    height: unset !important;
  }
}

.specification-int-float__container .specification-int-float__select {
  min-width: 200px;
  width: 100%;
}

.specification-int-float__container .specification-int-float__label {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;

  white-space: nowrap;
}

.specification-int-float__container .specification-int-float__description {
  color: #555768;

  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;

  white-space: pre-wrap;
}

.specification-int-float__dropdown__container .specification-int-float__add-button__container {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  padding: 8px;
}

.specification-int-float__dropdown__container .specification-int-float__custom-option {
  color: var(--color-blue-6);
}